export default __webpack_public_path__ + "static/media/banner-aside-recursos-para-trabajar-en-el-aula.fde77e21.gif";